import $ from 'jquery';

import 'owl.carousel';

import constants from './constants';

import {TestModule} from './App/TestModule';
import HeaderScrollHandler from './App/Exhibition/HeaderScrollHandler';
import ExhibitionImageCarousel from './App/Exhibition/ExhibitionImageCarousel';
import GalleryHandler from './App/Blocks/GalleryHandler';
import MainNavHandler from './App/SiteHeader/MainNavHandler';
import ElementInView from './App/ElementInView';
import JumpMenuHandler from './App/Blocks/JumpMenuHandler';
import ProductInfoHandler from './App/Blocks/ProductInfoHandler';
import MailchimpHandler from './App/Mailchimp/MailchimpHandler';
import ProductImageCarousel from './App/Product/ProductImageCarousel';
import EventBookingHandler from './App/EventBooking/EventBookingHandler';

import CookieConsent from '../../../src/Accelerator/Components/Modules/CookieConsent/resources/scripts/front/CookieConsent/CookieConsent';
import GoogleTrackingService from '../../../src/Accelerator/Components/Modules/CookieConsent/resources/scripts/front/CookieConsent/GoogleTrackingService.js';

let galleryHandler = new GalleryHandler();

window.test = $;

$(document).ready(() => {
    let googleTrackingService = new GoogleTrackingService();
    let cookieConsent = new CookieConsent();
	let testModule = new TestModule();
	let exhibitionImageCarousel = new ExhibitionImageCarousel();
	let jumpMenuHandler = new JumpMenuHandler();
	let fadeInScroll = new ElementInView(constants.FADE_IN_SCROLL_SELECTOR, constants.FADE_IN_SCROLL_ACTIVE_CLASS);
	let mailchimpHandler = new MailchimpHandler();
	let productInfoHandler = new ProductInfoHandler();
	let productImageCarousel = new ProductImageCarousel();
	galleryHandler.refresh();
});

$(window).on("load",() => {
	$('.block-exhibition-column--image-column--loading').removeClass('block-exhibition-column--image-column--loading');

	// When all assets are loaded
	let headerScroll = new HeaderScrollHandler();
	let mainNav = new MainNavHandler();
    let eventBookingHandler = new EventBookingHandler();

	galleryHandler.refresh();
});



// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/assets/scripts/src/main.js